import KpiCardLoadingShimmer from "../../common/reportDashBShimmer/KpiCardLoadingShimmer";
import { ErrorRetry } from "../../common/ErrorRetry";
import { KPICard } from "./KPICard";

export function ReportSummaryKpiSection({ state, summaryMetrics }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {state.loading ? (
        Array.from({ length: 4 }).map((_, idx) => (
          <KpiCardLoadingShimmer key={idx} />
        ))
      ) : state.error ? (
        <ErrorRetry message={state.message} onRetry={state.onRetry} />
      ) : summaryMetrics.length > 0 ? (
        summaryMetrics.map((kpi, idx) => (
          <KPICard
            key={kpi.label || idx}
            label={kpi.label}
            value={kpi.value}
            status={kpi.status}
            changePercentage={kpi.changePercentage}
            history={kpi.history}
            secondaryValue={kpi.secondaryValue}
            currency={kpi.currency}
          />
        ))
      ) : (
        <div className="col-span-full text-gray-500">No metrics available</div>
      )}
    </div>
  );
}
